__turbopack_context__.v({
  "count": "hashtag-autocomplete-module__bRLsxq__count",
  "list": "hashtag-autocomplete-module__bRLsxq__list",
  "mark": "hashtag-autocomplete-module__bRLsxq__mark",
  "option": "hashtag-autocomplete-module__bRLsxq__option",
  "path": "hashtag-autocomplete-module__bRLsxq__path",
});
